export var ERevampReportReducers;
(function (ERevampReportReducers) {
    ERevampReportReducers["HOLDING"] = "holdings";
    ERevampReportReducers["PNL"] = "pnlReport";
    ERevampReportReducers["FamilyTagging"] = "familyDetails";
    ERevampReportReducers["DownloadNSendEmailReport"] = "downloadNSendEmailReport";
    ERevampReportReducers["TAX_REVAMP"] = "tax_revamp";
    ERevampReportReducers["ACCOUNT_OVERVIEW"] = "accOverView";
    ERevampReportReducers["AccountOverviewMapDetails"] = "mapDetails";
    ERevampReportReducers["AccountOverviewAlertsOverview"] = "alertsOverview";
    ERevampReportReducers["AccountOverviewHoldingData"] = "AccountOverviewHoldingData";
    ERevampReportReducers["LEDGER_SNAPSHOT"] = "snapShot";
    ERevampReportReducers["LEDGER_DETAILS"] = "details";
    ERevampReportReducers["LEDGER_SNAPSHOT_EXTENTION"] = "snapShotExtention";
    ERevampReportReducers["LEDGER_CONTRACT_NOTE"] = "contractNote";
    ERevampReportReducers["CONTRACT_REPORT"] = "Contract";
    ERevampReportReducers["CONTRACT_REPORT_COMMODITY"] = "ContractCommodity";
    ERevampReportReducers["DPBILL"] = "DpBillsDetailsReport";
    ERevampReportReducers["DPINTEREST_DETAILS"] = "dpiDetails";
    ERevampReportReducers["DPCHARGES"] = "dpiCharges";
    ERevampReportReducers["SUBSCRIPTION_FEE"] = "SubscriptionFee";
    ERevampReportReducers["TRANSACTION_HISTORY"] = "TransactionHistory";
})(ERevampReportReducers || (ERevampReportReducers = {}));
